import React, { FC, useEffect, useState }  from "react";
import useScript from "../hooks/UseScript";


const GSOHeaderComponent: FC = () => {

  const [isLinkElementLoaded, setLinkElementLoaded] = useState(false)

  useEffect(() => {
  const linkElement = document.createElement("link");
        linkElement.setAttribute("rel", "stylesheet");
        linkElement.setAttribute("type", "text/css");
        linkElement.setAttribute("href",GetScriptUrl(false) + "gso-header.min.css");
        document.head.appendChild(linkElement);

        setLinkElementLoaded(true)
  }, []);

    const GetScriptUrl = (javascriptUrl : boolean) => {
        var urlHost = window.location.host.toString();
        var headerBaseUrl = 'https://online.groups.local/gso-header/';

        if(urlHost.includes('localhost'))
        {
            headerBaseUrl = 'https://devonline.groups.local/gso-header/';
        }
        else if(urlHost.includes('devservices') || urlHost.includes('devonline'))
        {
            headerBaseUrl = 'https://devonline.groups.local/gso-header/';
        }
        else if(urlHost.includes('qaservices') || urlHost.includes('qaonline'))
        {
            headerBaseUrl = 'https://qaonline.groups.be/gso-header/';
        }
        else
        {
            headerBaseUrl = 'https://online.groups.be/gso-header/';
        }

        if(javascriptUrl)
        {
            return headerBaseUrl + 'gso-header.min.js';
        }
        else
        {
            return headerBaseUrl;
        }
    }

    const gsoheaderScript = useScript(GetScriptUrl(true));

  return (
    <>
    {isLinkElementLoaded && 
      <header className="no-print">
        <div id="gso-header" data-base-url={GetScriptUrl(false)}></div>
      </header>
    }
    </>
  );
}

export default GSOHeaderComponent;